import { Head } from '@inertiajs/inertia-vue3';
import Icon from '@/Shared/Icon';
import pickBy from 'lodash/pickBy';
import Layout from '@/Shared/Layout';
import throttle from 'lodash/throttle';
import mapValues from 'lodash/mapValues';
import Pagination from '@/Shared/Pagination';
import SearchFilter from '@/Shared/SearchFilter';
import { Link } from '@inertiajs/inertia-vue3';
export default {
  components: {
    Head: Head,
    Icon: Icon,
    Pagination: Pagination,
    SearchFilter: SearchFilter,
    Link: Link
  },
  layout: Layout,
  props: {
    filters: Object,
    tenant_details: Object,
    internalTenants: Object
  },
  data: function data() {
    return {
      form: {
        tenant: this.filters.tenant,
        member: this.filters.member,
        start_date: this.filters.start_date,
        end_date: this.filters.end_date,
        campaign: this.filters.campaign
      },
      selected_field: "industry"
    };
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/tenant/report', pickBy(this.form), {
          preserveState: true
        });
      }, 150)
    }
  },
  methods: {
    reset: function reset() {
      this.form.member = null;
      this.form.start_date = null;
      this.form.end_date = null;
      this.form.campaign = null;
    },
    getTenantStatusClass: function getTenantStatusClass(status) {
      return {
        'pill active': status == 'active' || status == 'trial' || status == 'trialWithoutCard',
        'pill pause': status == 'defunct',
        'pill suspend': status == 'suspend' || status == 'grace',
        'pill pending': status == 'new'
      };
    }
  }
};